import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import PaymentPage from './pages/PaymentPage';
import TestPage from './pages/TestPage';
import ResultPage from './pages/ResultPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import StructuredCounselingPage from './pages/StructuredCounselingPage';
import CounselingReportsPage from './pages/CounselingReportsPage';
import CounselingReportView from './pages/CounselingReportView';
import AboutPage from './pages/AboutPage';
import CSRLogin from './pages/CSRLogin';
import CSRDashboard from './pages/CSRDashboard';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [csrPartner, setCSRPartner] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    const adminData = localStorage.getItem('admin');
    const csrData = localStorage.getItem('csr_partner');

    if (token && userData) {
      setUser(JSON.parse(userData));
    }

    if (token && adminData) {
      setAdmin(JSON.parse(adminData));
    }

    if (csrData) {
      setCSRPartner(JSON.parse(csrData));
    }
  }, []);

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
      return <Navigate to="/auth" />;
    }
    return children;
  };

  const AdminRoute = ({ children }) => {
    const adminData = localStorage.getItem('admin');
    if (!adminData) {
      return <Navigate to="/admin/login" />;
    }
    return children;
  };

  const CSRRoute = ({ children }) => {
    const csrToken = localStorage.getItem('csr_token');
    if (!csrToken) {
      return <Navigate to="/csr/login" />;
    }
    return children;
  };

  return (
    <div className="App bg-gradient-to-br from-indigo-50 via-white to-teal-50 min-h-screen">
      <div className="grain-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage setUser={setUser} />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <PaymentPage user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test"
            element={
              <ProtectedRoute>
                <TestPage user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/result"
            element={
              <ProtectedRoute>
                <ResultPage user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counseling"
            element={
              <ProtectedRoute>
                <StructuredCounselingPage user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counseling/reports"
            element={
              <ProtectedRoute>
                <CounselingReportsPage user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counseling/report/:reportId"
            element={
              <ProtectedRoute>
                <CounselingReportView user={user} />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/login" element={<AdminLogin setAdmin={setAdmin} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboard admin={admin} setAdmin={setAdmin} />
              </AdminRoute>
            }
          />
          {/* CSR Partner Routes */}
          <Route path="/csr/login" element={<CSRLogin setCSRPartner={setCSRPartner} />} />
          <Route
            path="/csr/dashboard"
            element={
              <CSRRoute>
                <CSRDashboard csrPartner={csrPartner} setCSRPartner={setCSRPartner} />
              </CSRRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;